import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/** 공고 상세 — 목록(`/announcements`)은 공고 찾기(`features/finder`, specs/031)가 소유한다. */
export const announcementRoutes: RouteObject[] = [
  {
    path: 'announcements/:id',
    lazy: page('AnnouncementDetailPage'),
    handle: { title: '공고 상세', feature: 'ANNOUNCEMENT_FINDER' } satisfies RouteHandle,
  },
];
